@import 'styles/mixins';
@import 'styles/variables';

.plusButton {
  transform: translateY(var(--offsetY, 0px));
  width: 16px;
  min-height: 24px;
  padding: 0;

  &::after {
    // Provides a bigger hover area for the insert handle
    content: '';
    display: block;
    width: 30px;
    height: 30px;
    position: absolute;
  }

  svg {
    // A little bit smaller than the usual 16px to match the designs.
    width: 14px !important;
    height: 14px !important;
  }
}
